import { Theme } from '@mui/material'

export const matchesDesktop = (theme: Theme): string => theme.breakpoints.up('sm')

export const matchesMobile = (theme: Theme): string => theme.breakpoints.down('sm')

export const matchesSmallMobile = (theme: Theme): string => theme.breakpoints.down(385)
